interface BrandLogoProps {
  variant?: 'dark' | 'light'
  kind?: 'mark' | 'wordmark' | 'lockup'
  className?: string
  /** @deprecated Use kind="mark" so square marks and wordmarks cannot be confused. */
  markOnly?: boolean
  alt?: string
}

const brandAssets = {
  mark: {
    dark: '/branding/pureit-symbol-primary.svg',
    light: '/branding/pureit-symbol-white.svg',
    width: 820,
    height: 300,
  },
  wordmark: {
    dark: '/branding/pureit-wordmark-primary.svg',
    light: '/branding/pureit-wordmark-white.svg',
    width: 1200,
    height: 320,
  },
  lockup: {
    dark: '/branding/pureit-lockup-primary.svg',
    light: '/branding/pureit-lockup-white.svg',
    width: 1200,
    height: 900,
  },
} as const

const BrandLogo = ({
  variant = 'dark',
  kind = 'wordmark',
  className = '',
  markOnly = false,
  alt = 'PureIT',
}: BrandLogoProps) => {
  const assetKind = markOnly ? 'mark' : kind
  const asset = brandAssets[assetKind]

  return (
    <img
      src={asset[variant]}
      width={asset.width}
      height={asset.height}
      alt={alt}
      className={className || 'h-8 w-auto'}
    />
  )
}

export default BrandLogo
